module.exports = __webpack_public_path__ + "static/media/test768x832.203b55d4.jpg";